// Checking if urls are the same with encoding to prevent double back-click issue
function initPushStateInterceptor() {
  const originalPushState = history.pushState;
  let isFirstPushState = true;

  function normalizeUrl(url) {
    const tempUrl = new URL(String(url), window.location.origin);
    try {
      return decodeURIComponent(String(tempUrl)).replace(/\+/g, " ");
    } catch (e) {
      return String(tempUrl).replace(/\+/g, " ");
    }
  }

  function removeAlgoliaParams(url) {
    return url
      .replace(/&?sortBy=[^&]*/g, "")
      .replace(/&?page=[^&]*/g, "")
      .replace(/\?$/, "");
  }

  history.pushState = function (state, title, url) {
    if (url) {
      const currentUrl = window.location.pathname + window.location.search;
      const normalizedCurrent = removeAlgoliaParams(normalizeUrl(currentUrl));
      const normalizedNew = removeAlgoliaParams(normalizeUrl(url));

      if (isFirstPushState && normalizedCurrent === normalizedNew) {
        isFirstPushState = false;
        return history.replaceState(state, title, url);
      }
      isFirstPushState = false;
    }
    return originalPushState.call(this, state, title, url);
  };
}

// Wait for the element to be present in the DOM
function waitForElement(selector, callback, timeout = 5000, interval = 100) {
  const startTime = Date.now();
  function check() {
    const element = document.querySelector(selector);
    if (element) {
      try {
        callback(element);
      } catch (err) {
        console.error(`waitForElement: Error in callback for "${selector}":`, err);
      }
    } else if (Date.now() - startTime < timeout) {
      setTimeout(check, interval);
    } else {
      console.warn(`waitForElement: Element "${selector}" not found within ${timeout}ms`);
    }
  }
  check();
}

initPushStateInterceptor();
